import { DespachoInfoCallout, DespachoSectionCard } from "@/components/despacho/DespachoUi";

export default function CalendarioClientWhatsappPanel() {
  return (
    <div className="space-y-4" data-testid="calendario-client-whatsapp-info">
      <DespachoInfoCallout>
        El envío por <strong>WhatsApp Business API</strong> se habilitará en una fase posterior, con la misma
        lógica que <strong>Mensajes generales</strong> del correo (campañas, empresas, auxiliar y selección).
        Mientras tanto use <strong>Recordatorios a Clientes (correo electrónico)</strong>.
      </DespachoInfoCallout>

      <DespachoSectionCard title="Cuando esté activo hará falta">
        <ul className="text-sm text-slate-700 space-y-2 m-0 pl-4 list-disc">
          <li>Teléfono WhatsApp y consentimiento en la ficha de cada cliente.</li>
          <li>Cuenta Meta / WhatsApp Business del despacho.</li>
          <li>Plantillas aprobadas por Meta (tipos de mensaje del canal).</li>
        </ul>
      </DespachoSectionCard>
    </div>
  );
}
